/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { ReactComponent as Search } from "cms/assets/icons/search.svg";
import { PermitSearchInput } from "components/search/permit-search";

const PublicSearch = (props) => {
    const { onChangeHandler, onSearchHandler, onSelectOption, resetFetch, queryValue } = props;
    return (
        <div className="full-search-query">
            <div className="full-search-input">
                <PermitSearchInput
                    onChangeHandler={onChangeHandler}
                    onSelectOption={onSelectOption}
                    resetFetch={resetFetch}
                    queryValue={queryValue}
                    placeholder="Search by permit number or street address"
                />
            </div>
            <div className="search-cta">
                <button className="search-btn" onClick={onSearchHandler}>
                    <Search />
                </button>
            </div>
        </div>
    );
};

export { PublicSearch };
